import apiEndPoints from "../../../routeConfig";
import { ApiService } from "../../../../service/api.service";

const apiService = new ApiService();

export const userTypeCreateUpdate = async (data, editMode, id,) => {
  let url
  let result
  if (editMode === true) {
    url = `${apiEndPoints.userTypeCreateOrUpdate}/userType/${id}`
  } else {
    url = `${apiEndPoints.userTypeCreateOrUpdate}/userType`
  }
  if (editMode === true) {
    await apiService.update(url, data).then(response => {
      result = response;
    }).catch(error => {
      result = error;
    })
  } else {
    await apiService.post(url, data).then(response => {
      result = response;
    }).catch(error => {
      result = error;
    })
  }
  return result;
}

export const getAlluserType = async (page = 0, limit = 10) => {
  try {
    const response = await apiService.get(`${apiEndPoints.getAlluserType}/userType?page=${page + 1}&limit=${limit}`,);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const userTypeGetById = async (id) => {
  let result;
  await apiService.get(`${apiEndPoints.userTypeGetById}/userType/${id}`)
    .then((response) => {
      result = response.data;
    })
    .catch(error => {
      result = error;
    });
  return result;
};

export const deleteUserType = async (id) => {
  try {
    const response = await apiService.patch(`${apiEndPoints.deleteUserType}/userType/${id}/status/DELETED`, '');
    return response;
  } catch (error) {
    return error;
  }
};

export const patchApi = async (id, statusUpdate) => {
  try {
    const response = await apiService.patch(`${apiEndPoints.patchApi}/userType/${id}/status/${statusUpdate}`, '');
    return response;
  } catch (error) {
    return error;
  }
};

export const countryMetaData = async () => {
  let result;
  await apiService.get(`${apiEndPoints.countryMetaData}`)
    .then((response) => {
      result = response.data;
    })
    .catch(error => {
      result = error;
    });
  return result;
};
